import { track } from 'ha/modules/Analytics/actions';
import reportError from 'ha/helpers/bugsnag/reportError';
import { Thunk } from 'ha/myredux/types';

import {
  SearchAlert,
  SearchAlertChannel,
  SearchAlertFrequency,
} from 'ha/services/bell';

import {
  getSearchAlert,
  getSearchAlertParams,
} from '../selectors/searchAlertSelectors';
import { UpsertActions } from './searchAlertActions';

const DefaultTimezone = 'Europe/Berlin';

export default (
    title?: string,
    frequency?: SearchAlertFrequency,
    channel?: SearchAlertChannel,
    filterLast24Hours?: boolean,
  ): Thunk =>
  (dispatch, getState, services) => {
    const state = getState();

    dispatch(UpsertActions.start());

    const timezone =
      typeof Intl === 'object'
        ? new Intl.DateTimeFormat().resolvedOptions().timeZone
        : DefaultTimezone;

    const searchAlert = getSearchAlert(state);
    const searchAlertParams = getSearchAlertParams(state);

    if (filterLast24Hours) {
      searchAlertParams.filters.recentlyAdded = '1-day';
    }

    let upsertBellPromise: Promise<SearchAlert> | null = null;

    const apiCallParams = {
      ...searchAlertParams,
      timezone,
      alias: title || searchAlertParams.alias,
      channel: channel || 'email',
      frequency: frequency || 'daily',
    };

    if (!searchAlert) {
      upsertBellPromise = services.bell.createSearchAlert(apiCallParams);
    } else {
      upsertBellPromise = services.bell.editSearchAlert({
        alertID: searchAlert.alertID,
        ...apiCallParams,
      });
    }

    return upsertBellPromise
      .then(bellResponse => {
        dispatch(
          UpsertActions.done({
            searchAlert: bellResponse,
          }),
        );
        dispatch(
          track('Search alert updated', {
            cityCanonical: searchAlertParams.city,
          }),
        );
      })
      .catch(error => {
        reportError('UpsertSearchResult error', { metaData: { error } });
        dispatch(UpsertActions.error());
      });
  };
